var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.0147 24.2579C52.0147 23.8896 51.7134 23.5882 51.3451 23.5882L45.8205 23.6133L37.5002 33.5324L29.1883 23.6217L23.6554 23.5966C23.2871 23.5966 22.9857 23.8896 22.9857 24.2662C22.9857 24.4253 23.0443 24.576 23.1448 24.7015L34.0348 37.6758L23.1448 50.6418C23.0436 50.7645 22.9875 50.9181 22.9857 51.0771C22.9857 51.4454 23.2871 51.7467 23.6554 51.7467L29.1883 51.7216L37.5002 41.8025L45.8122 51.7132L51.3367 51.7383C51.705 51.7383 52.0064 51.4454 52.0064 51.0687C52.0064 50.9097 51.9478 50.759 51.8473 50.6334L40.974 37.6675L51.8641 24.6931C51.9645 24.576 52.0147 24.4169 52.0147 24.2579Z",
    fill: "#2F2D30"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 0C16.7913 0 0 16.7913 0 37.5C0 58.2087 16.7913 75 37.5 75C58.2087 75 75 58.2087 75 37.5C75 16.7913 58.2087 0 37.5 0ZM37.5 68.6384C20.3069 68.6384 6.36161 54.6931 6.36161 37.5C6.36161 20.3069 20.3069 6.36161 37.5 6.36161C54.6931 6.36161 68.6384 20.3069 68.6384 37.5C68.6384 54.6931 54.6931 68.6384 37.5 68.6384Z",
    fill: "#2F2D30"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.4ef97cf8d7e35c723f64996bde2324c5.svg";
export { ForwardRef as ReactComponent };